<div class="modal">
  <div class="modal__header">
    <div class="modal__title">
      {{ '+COMMERCIAL.MODAL.UPGRADE_TITLE' | translate }}
    </div>
    <div class="modal__close">
      <button
        mat-icon-button
        (click)="close()"
        gtm="onClose"
        gtmAction="Close update commercial modal"
        gtmCategory="closeBooking"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="modal_body flex flex-row">
    <div class="flex flex-col">
      <p class="modal__description">
        {{ '+COMMERCIAL.MODAL.UPGRADE_TEXT' | translate }}
      </p>
      <div class="modal__checklist">
        <div class="modal__label">
          <mat-icon class="modal__icon">check_circle</mat-icon>
          <span>{{ '+COMMERCIAL.MODAL.SYSTEM' | translate }}</span>
        </div>
        <div class="modal__label">
          <mat-icon class="modal__icon">check_circle</mat-icon>
          <span>{{ '+COMMERCIAL.MODAL.DATA_TRENDING' | translate }}</span>
        </div>
        <div class="modal__label">
          <mat-icon class="modal__icon">check_circle</mat-icon>
          <span>{{ '+COMMERCIAL.MODAL.INSPECTION' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="modal__video flex flex-row">
      <iframe
        width="265px"
        height="148px"
        src="https://www.youtube.com/embed/Uz4NHSQFWjE"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </div>

  <div class="modal__button">
    <button
      mat-raised-button
      color="primary"
      gtm="onGoToPage"
      gtmAction="Redirect to booking page"
      gtmCategory="booking"
      (click)="onUpgradeNow()"
    >
      <span>{{ '+COMMERCIAL.MODAL.UPGRADE_NOW' | translate }}</span>
    </button>
  </div>
</div>
